module.exports = __webpack_public_path__ + "assets/img/logistica-rakumart.4bd5806a.jpg";